import React from 'react';

import StorytellerUtils from 'lib/StorytellerUtils';
import { ReactRendererProps } from '../shared/ComponentRegistry';

/**
 * React component renderer for horizontal rule components.
 */
export const ComponentHorizontalRule: React.FC<ReactRendererProps> = ({ componentData }) => {
  const typeClasses = StorytellerUtils.typeToClassesForComponentType(componentData.type);

  return (
    <div className={`component ${typeClasses} typeset`}>
      <hr />
    </div>
  );
};
